import React, { Fragment } from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const AssoiciatedTableHeader = () => {
    const styles = StyleSheet.create({
        assoiciatedcontainer: {
            flexDirection: 'row',
            backgroundColor: '#E4E4E4',
            alignItems : 'center',
            fontStyle: 'bold',
            paddingBottom : '5px',
            paddingTop : '10px',
            paddingLeft : '15px'
        },
        report: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        date: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        recorded: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        reference:{
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        amount: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
    });
    return (
        <Fragment>
            <View style={styles.assoiciatedcontainer}>
                <Text style={styles.report}>Report ID</Text>
                <Text style={styles.date}>Date - Time</Text>
                <Text style={styles.recorded}>Recorded By</Text>
                <Text style={styles.reference}>Reference</Text>
                <Text style={styles.amount}>Amount</Text>
            </View>
        </Fragment>
    )
}

export default AssoiciatedTableHeader;